import { Button, ButtonGroup } from "@oysterhr/ui"
import { ComponentProps, useState } from "react"

interface Value {
  label: string
  value: string
}

interface ToggleButtonProps {
  className?: string
  defaultValue?: string
  values: Value[]
  onChange: (value: string) => void
  size?: ComponentProps<typeof Button>["size"]
  type?: ComponentProps<typeof Button>["type"]
}

function ToggleButton({
  className,
  defaultValue,
  values,
  onChange,
  size,
  type,
}: ToggleButtonProps) {
  const [state, setState] = useState(defaultValue || values[0].value)

  const handlerChange = (value: string) => {
    setState(value)
    if (typeof onChange === "function") {
      onChange(value)
    }
  }

  return (
    <ButtonGroup size={size} active={state} className={className}>
      {values.map(({ value, label }) => (
        <Button key={value} id={value} onClick={() => handlerChange(value)} type={type}>
          {label}
        </Button>
      ))}
    </ButtonGroup>
  )
}

export default ToggleButton
